
import sliderRangeImg from '../components/slider-range-img';

export default () => {


    sliderRangeImg()

};
